import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { Directive, forwardRef, Input } from '@angular/core';

export function PasswordMatchValidator(matchTo: AbstractControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value || control.value.length === 0) {
            return null;
        }

        if (matchTo.value !== control.value) {
            return { passwordMatch: true };
        }

        return null;
    };
}

@Directive({
    selector: '[validatePasswordMatch][formControlName],[validatePasswordMatch][formControl],[validatePasswordMatch][ngModel]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => PasswordMatchValidatorDirective),
            multi: true,
        },
    ],
})
export class PasswordMatchValidatorDirective implements Validator
{
    @Input() matchTo: AbstractControl = null;

    validate(control: AbstractControl): { [key: string]: any } {
        const validator = PasswordMatchValidator(this.matchTo);
        return validator(control);
    }
}
